import { render } from "./WhiteAlert.vue?vue&type=template&id=ef65fbe4&scoped=true"
import script from "./WhiteAlert.vue?vue&type=script&lang=js"
export * from "./WhiteAlert.vue?vue&type=script&lang=js"

import "./WhiteAlert.vue?vue&type=style&index=0&id=ef65fbe4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef65fbe4"]])

export default __exports__